import * as React from 'react'

const RULES_URL = 'https://holidaypark.pl/regulaminy/pobierz/regulamin-swiadczenia-uslug-droga-elektroniczna/'

export const RulesView = (): React.ReactNode => {
  window.location.href = RULES_URL

  return null
}
